export function kitIndexValidate(kit){
    var result = true;

    result = validateId(kit.id);
    if(!result) return result;

    result = validateSku(kit.sku);
    if(!result) return result;

    result = validateDescription(kit.description);
    if(!result) return result;

    result = validateClientName(kit.client_name);
    if(!result) return result;

    result = validateIncludedProductsCount(kit.included_products_count);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateSku(sku) {
    if(typeof sku == "string" && sku != "") return true;
    else return false;
}

function validateDescription(description) {
    if(typeof description == "string" && description != "") return true;
    else return false;
}

function validateClientName(client_name) {
    if(typeof client_name == "string" && client_name != "") return true;
    else return false;
}

function validateIncludedProductsCount(included_products_count){    
    if(Number.isInteger(included_products_count)) return true;
    else return false;
}